import { supabase } from "@/lib/supabase";
import { readWorkspaceOrgIdFromStorage } from "@/lib/workspaceOrgStorage";

export const BASE = "/api/ops/paperwork";

export type FetchResult<T> =
  | { ok: true; status: number; data: T }
  | { ok: false; status: number; error: string; skipped?: Array<{ id: string; reason: string }> };

export async function opsFetch<T>(path: string, init: RequestInit = {}): Promise<FetchResult<T>> {
  if (!supabase) return { ok: false, status: 503, error: "App is not configured for sign-in." };
  const {
    data: { session },
  } = await supabase.auth.getSession();
  const token = session?.access_token;
  if (!token) return { ok: false, status: 401, error: "Sign in required." };

  const headers: HeadersInit = {
    Authorization: `Bearer ${token}`,
    ...(init.headers || {}),
  };
  const ws = readWorkspaceOrgIdFromStorage();
  if (ws) (headers as Record<string, string>)["X-Workspace-Organization-Id"] = ws;

  const r = await fetch(path, { ...init, headers });
  const text = await r.text();
  let json: unknown = null;
  try {
    json = JSON.parse(text) as T;
  } catch {
    /* non-JSON */
  }
  if (!r.ok) {
    const body = json && typeof json === "object" && json !== null ? (json as Record<string, unknown>) : null;
    const err =
      body && typeof body.error === "string"
        ? body.error
        : text || `HTTP ${r.status}`;
    const skippedRaw = body?.skipped;
    const skipped = Array.isArray(skippedRaw)
      ? skippedRaw.filter(
          (row): row is { id: string; reason: string } =>
            !!row &&
            typeof row === "object" &&
            typeof (row as { id?: unknown }).id === "string" &&
            typeof (row as { reason?: unknown }).reason === "string"
        )
      : undefined;
    return { ok: false, status: r.status, error: err, ...(skipped?.length ? { skipped } : {}) };
  }
  return { ok: true, status: r.status, data: json as T };
}

export function q(ops: string, extra?: Record<string, string>) {
  const p = new URLSearchParams({ ops });
  if (extra) for (const [k, v] of Object.entries(extra)) p.set(k, v);
  return `${BASE}?${p.toString()}`;
}
